const executives =
    [
        {
            name: "VERENICE",
            position: "Servicio al cliente",
            phoneFormatted: "(443)-338-2109",
            phone: "4433382109",
            email: "contacto@naranti.com.mx",
            officePhoneNumberFormatted: "(443)-338-2109",
            officePhoneNumber: "4433382109",
            gender: "F"
        }
    ];
const currentExecutive = executives[Math.floor(Math.random() * executives.length)]
const initialState = {
    media: {
        map: null,
        filters: [],
        mediaList: [],
        mediaFiltered: [],
        markersList: [],
        mapCircleList: [],
        pointsOfInterest: {},
        markerClusterer: null,
        favoriteMediaList: [],
        showMediaModal: false,
        showContactModal: false,
        currentMedium: null,
        executives: executives,
        currentExecutive: currentExecutive,
        loading: true,
        country: null,
        viewOnlyFavoriteList: false,
        fetchProgress: { loaded: 0, total: 0 }
    },
}

export default initialState;